import React, { PureComponent } from 'react';
import { connect } from 'react-redux';

// Components
import { Spin, Modal, Form, Row, Col, Alert, Input, InputNumber, Select, Icon } from 'antd';

// Selectors
import { getAddOrEditDeviceModalIsLoading } from '../../../data/homes/selectors';
import { getDeviceTypesList, getAllDeviceTypesAreLoading } from '../../../data/deviceTypes/selectors';
import { selectedLangageSelector } from '../../../data/app/selector';

// Actions
import { onAddNewDeviceForMeter, onEditDeviceForMeter } from '../../../data/homes/actions';

// Constants
import { MODAL_SIZES } from '../../../constants/modal';

class AddOrEditDeviceModal extends PureComponent {
    handleSubmit = () => {
        const { form } = this.props;

        form.validateFields((err, values) => {
            if (err) {
                return;
            }

            const {
                recordToEdit,
                msgs,
                params,
                meterId,
                onAddNewDeviceForMeter,
                onEditDeviceForMeter
            } = this.props;
            if (!recordToEdit) {
                onAddNewDeviceForMeter(meterId, values, params)
                    .then(() => {
                        // const { fetchDeviceForMeter } = this.props;
                        // fetchDeviceForMeter(record.meter);
                    })
                    .catch(() => {
                        form.setFieldsValue({
                            hasError: msgs.homes.addHomeError
                        });
                    });
            } else {
                onEditDeviceForMeter(meterId, recordToEdit.id, values, params)
                    .then(() => {
                        // const { meterId } = this.props;
                        // const { fetchDeviceForMeter } = this.props;
                        // fetchDeviceForMeter(record.meter);
                    })
                    .catch(() => {
                        form.setFieldsValue({
                            hasError: msgs.homes.editHomeError
                        });
                    });
            }
        });
    };

    handleAlertClose = () => {
        const { form } = this.props;
        form.setFields({
            hasError: {
                value: undefined
            }
        });
    };

    render() {
        const {
            form,
            isShown,
            isLoading,
            msgs,
            isAdmin,
            onCancel,
            recordToEdit,
            deviceTypesList,
            deviceTypesListIsLoading,
            lang
        } = this.props;
        if(!deviceTypesList) return null;
        const { getFieldValue, getFieldDecorator } = form;
        return (
            <Modal
                key="admin-users-modal-add-or-edit"
                visible={isShown}
                confirmLoading={isLoading}
                width={MODAL_SIZES.MEDIUM}
                title={
                    !recordToEdit
                        ? msgs.homes.detail.addDeviceModalTitle
                        : `${msgs.homes.detail.editDeviceModalTitle} - ${
                              recordToEdit ? recordToEdit.name : ''
                          }`
                }
                onCancel={onCancel}
                onOk={this.handleSubmit}
                cancelText={msgs.cancel}
                okText={msgs.save}
            >
                <Spin spinning={isLoading} size="large">
                    <Form>
                        {getFieldValue('hasError') && (
                            <Row>
                                <Col xs={24}>
                                    <Alert
                                        message={getFieldValue('hasError')}
                                        type="error"
                                        showIcon
                                        closable
                                        onClose={this.handleAlertClose}
                                    />
                                </Col>
                            </Row>
                        )}
                        <Row gutter={8}>
                            <Col xs={24}>
                                <Form.Item label={msgs.homes.detail.deviceName}>
                                    {getFieldDecorator('name', {
                                        initialValue: recordToEdit ? recordToEdit.name : undefined,
                                        rules: [{ required: true, message: msgs.requiredField }]
                                    })(<Input type="text" />)}
                                </Form.Item>
                            </Col>
                        </Row>

                        {isAdmin && <Row gutter={8}>
                            <Col xs={24}>
                                <Form.Item label={msgs.homes.detail.deviceQuality}>
                                    {getFieldDecorator('quality', {
                                        initialValue: recordToEdit ? recordToEdit.quality : null
                                    })(
                                        <InputNumber
                                            disabled={!isAdmin}
                                            style={{ width: '100%' }}
                                            min={1}
                                            max={10}
                                        />
                                    )}
                                </Form.Item>
                            </Col>
                        </Row>}

                        <Row gutter={8}>
                            <Col xs={24}>
                                <Form.Item label={msgs.homes.detail.deviceType}>
                                    {getFieldDecorator('type', {
                                        initialValue:
                                            recordToEdit &&
                                            recordToEdit.deviceType &&
                                            recordToEdit.deviceType.id,
                                        rules: [{ required: true, message: msgs.requiredField }]
                                    })(
                                        <Select
                                            type="text"
                                            dropdownMatchSelectWidth={false}
                                            placeholder={
                                                deviceTypesListIsLoading ? msgs.loading : msgs.select
                                            }
                                            notFoundContent={
                                                !deviceTypesListIsLoading ? (
                                                    <span>
                                                        <Icon type="loading" />
                                                        {` ${msgs.loading}`}
                                                    </span>
                                                ) : (
                                                    <span>{msgs.noData}</span>
                                                )
                                            }
                                        >
                                            {deviceTypesList.sort((a,b) =>
                                                lang === 'zh' ? (a.name_zh > b.name_zh ? 1 : a.name_zh < b.name_zh ? -1 : 0) :
                                                    (lang === 'sk' ? (a.name_sk > b.name_sk ? 1 : a.name_sk < b.name_sk ? -1 : 0) :
                                                    (lang === 'de' ? (a.name_de > b.name_de ? 1 : a.name_de < b.name_de ? -1 : 0) :
                                                        (a.name > b.name ? 1 : a.name < b.name ? -1 : 0)))).map(item => (
                                                <Select.Option value={item.id} key={`typ${item.id}`}>
                                                    {lang === 'zh' ? item.name_zh : (lang === 'sk' ? item.name_sk : (lang === 'de' ? item.name_de : item.name))}
                                                </Select.Option>
                                            ))}
                                        </Select>
                                    )}
                                </Form.Item>
                            </Col>
                        </Row>

                        <Row gutter={8}>
                            <Col xs={24}>
                                <Form.Item label={msgs.homes.detail.deviceCountLabel}>
                                    {getFieldDecorator('count', {
                                        initialValue: recordToEdit ? recordToEdit.count : 1
                                    })(
                                        <InputNumber
                                            style={{ width: '100%' }}
                                            min={1}
                                            max={4}
                                        />
                                    )}
                                </Form.Item>
                            </Col>
                        </Row>

                    </Form>
                </Spin>
            </Modal>
        );
    }
}

export default connect(
    (state, ownProps) => ({
        ...ownProps,
        isLoading: getAddOrEditDeviceModalIsLoading(state),
        deviceTypesList: getDeviceTypesList(state),
        deviceTypesListIsLoading: getAllDeviceTypesAreLoading(state),
        lang: selectedLangageSelector(state)
    }),
    {
        onAddNewDeviceForMeter,
        onEditDeviceForMeter
    }
)(Form.create()(AddOrEditDeviceModal));
